<div class="fdx-o-grid__row fdx-o-grid__row--center">
  <div
    class="fdx-o-grid__item fdx-o-grid__item--12@large fdx-o-grid__item--11 fdx-u-align--center">
    <p class="fdx-c-heading fdx-c-heading--h5">
      <ng-content></ng-content>
    </p>
  </div>
</div>
